import { Grid, TextField, Typography } from "@mui/material";
import PrimaryButton from "components/PrimaryButton";
import SecondaryButton from "components/SecondaryButton";
import { Maybe } from "graphql/jsutils/Maybe";
import { FC, useCallback, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface CustomerEmailInputProps {
  initialEmail?: Maybe<string>;
  onCancel: () => void;
  onSendEmail: (email: string) => void;
}

export const CustomerEmailInput: FC<CustomerEmailInputProps> = (props) => {
  const { initialEmail, onCancel, onSendEmail } = props;
  const [customerEmailInput, setCustomerEmailInput] = useState<string>(initialEmail ?? "");
  const [sentEmail, setSentEmail] = useState<boolean>(false);
  const intl = useIntl();

  const onCancelClicked = useCallback(() => {
    setCustomerEmailInput("");
    onCancel();
  }, [onCancel]);

  const onSendEmailClicked = useCallback(() => {
    setSentEmail(true);
    onSendEmail(customerEmailInput);
  }, [customerEmailInput, onSendEmail]);

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Typography>
          <FormattedMessage id="remoteAccess.customerSendEmailText" />
        </Typography>
      </Grid>

      {sentEmail && customerEmailInput && (
        <Grid item>
          <Typography>
            <FormattedMessage id="remoteAccess.emailSentTo" /> {customerEmailInput}
          </Typography>
        </Grid>
      )}

      <Grid item>
        <TextField
          style={{ backgroundColor: "white" }}
          label={intl.formatMessage({ id: "remoteAccess.customerEmail" })}
          fullWidth
          autoFocus
          value={customerEmailInput}
          onChange={(e) => {
            setCustomerEmailInput(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              let inputField = e.currentTarget?.querySelector?.("input");
              inputField?.blur?.();
              onSendEmailClicked();
            }
          }}
        />
      </Grid>
      <Grid item>
        <PrimaryButton onClick={onSendEmailClicked} disabled={!customerEmailInput}>
          <FormattedMessage id="remoteAccess.sendByEmail" />
        </PrimaryButton>
      </Grid>
      <Grid item>
        <SecondaryButton onClick={onCancelClicked}>
          <FormattedMessage id="general.cancel" />
        </SecondaryButton>
      </Grid>
    </Grid>
  );
};
